module.exports = __webpack_public_path__ + "img/thats-all-folks.c25e3243.jpg";